import { render, staticRenderFns } from "./EditCuentaBancaria.vue?vue&type=template&id=33ef5303"
import script from "./EditCuentaBancaria.vue?vue&type=script&lang=js"
export * from "./EditCuentaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports